import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import {
  CloseButton,
  DetailInfoLine,
  EventDetailBody,
  ModalBackdrop,
  ModalContent,
  ModalImageContainer,
  ModalTitle,
  PlaceAddress,
  PlaceInfoContainer,
  PlaceName
} from "components/common/modals/modal.styles";
import React from "react";

interface EventDetailModalProps {
  event: {
    id: number;
    activity_title: string;
    activity_description?: string;
    start_date_time: string;
    end_date_time: string;
    imageUrl?: string;
    places?: Array<{
      place_city: string;
      place_state: string;
      place_postcode?: string;
      place_name?: string;
    }>;
  };
  onClose: () => void;
}

const EventDetailModal: React.FC<EventDetailModalProps> = ({ event, onClose }) => {
  const formatTime = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <ModalBackdrop>
      <ModalContent>
        <CloseButton onClick={onClose}>×</CloseButton>

        <ModalTitle>{event.activity_title}</ModalTitle>
        <ModalImageContainer>
          {event.imageUrl ? (
            <img
              src={event.imageUrl}
              alt={event.activity_title}
            />
          ) : (
            <span>Event Image</span>
          )}
        </ModalImageContainer>

        <EventDetailBody>
          {event.activity_description || "No description available."}
        </EventDetailBody>

        <DetailInfoLine>
          <AccessTimeIcon />
          {`${new Date(event.start_date_time).toLocaleDateString()} 
          ${formatTime(event.start_date_time)} - ${formatTime(event.end_date_time)}`}
        </DetailInfoLine>

        {event.places && event.places.length > 0 && (
          <DetailInfoLine>
            <LocationOnIcon />
            <PlaceInfoContainer>
              {event.places[0].place_name && (
                <PlaceName>{event.places[0].place_name}</PlaceName>
              )}
              <PlaceAddress>
                {`${event.places[0].place_city}, ${event.places[0].place_state} ${event.places[0].place_postcode || ''}`}
              </PlaceAddress>
            </PlaceInfoContainer>
          </DetailInfoLine>
        )}
      </ModalContent>
    </ModalBackdrop>
  );
};

export default EventDetailModal;